'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {

    var columns = [{
        id: 'edit',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return props.onClickEditYear(col.original.id);
                    } },
                'edit'
            );
        }
    }, {
        Header: 'Id',
        accessor: 'id',
        width: 240
    }, {
        Header: 'Nome',
        accessor: 'name'
    }];

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactTable2.default, {
            data: props.years,
            columns: columns,
            loading: props.loading,
            previousText: 'Anterior',
            nextText: 'Pr\xF3xima',
            loadingText: 'Carregando...',
            noDataText: 'N\xE3o foram encontrados anos para este filtro',
            pageText: 'P\xE1gina',
            ofText: 'de',
            rowsText: 'linhas',
            showPaginationBottom: true,
            width: 100,
            defaultPageSize: 10,
            filterable: true
        })
    );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/years/YearsList.js
// module id = 3246
// module chunks = 0